import React, { Fragment, useEffect, useRef, useState } from 'react';
import Box, { Item } from 'devextreme-react/box';
import { SearchInput } from '../../common/SearchInput';
import { useDispatch, useSelector } from 'react-redux';
import { associateContract, getContract, getContractSimple, getContractByCaseId } from '../../../redux/contract/thunks';
import { selectCurrentCase } from '../../../redux/currentCase/selectors';
import { markCaseWithoutCNPJ, markCaseWithoutPlate } from '../../../redux/cases/thunks.js';
import { selectContract, selectContractLoading } from '../../../redux/contract/selectors';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentMedical, faDollarSign, faExclamationTriangle, faUsers, faCar, faHourglassHalf, faCheck } from '@fortawesome/free-solid-svg-icons';
import { faVuejs } from '@fortawesome/free-brands-svg-icons';
import { openModal } from '../../../redux/modal/modalSlice';
import saveIcon from '../../../images/iconGuardar.svg';
import iconoAdd from '../../../images/iconoAdd.svg';
import iconEditarLead from '../../../images/iconEditarLead.svg';

import check from '../../../images/check.svg';
import check_green from '../../../images/check_green.svg';

import { IconButton } from '@material-ui/core';
import { NoneSelectedMessage } from '../../common/NoneSelected';
import { Gauge } from '../../common/Gauge';
import { useLocation } from 'react-router-dom';
import { AccordionGroup } from './Accordion';
import CustomerDialog from './CustomerDialog.js';
import { postCreateCustomer, postUpdateCustomer } from '../../../redux/customers/thunks';

import { validateEmail, validateCNPJ } from '../../../commonFunctions/commonFunctions.js';
import { formatToCNPJ, formatToCEP } from '../../../commonFunctions/FormatterFunctions';
import { errorHandler } from '../../../commonFunctions/errorHandler';

function ReadOnlyInput(props) {
  return (
    <div className={props.classStyle || 'input-wrapper-col'} style={props.expired ? { color: 'red' } : null}>
      <label>{props.label}</label>
      <div title={props.field?.length > 80 ? props.tooltip : null}>{props.date ? (props.field ? dayjs(props.field, 'DD/MM/YYYY').format('DD/MM/YYYY') : null) : props.field}</div>
    </div>
  );
}

function ReadOnlyModelInput(props) {
  return (
    <div className={props.classStyle || 'input-wrapper-col'} style={props.expired ? { ...props.style, color: 'red' } : { ...props.style }}>
      <label>
        {props.label}
        {props.showEditIcon && (
          <IconButton onClick={(e) => props.openEditForm(props.modelData)} style={{ padding: 5, marginLeft: 5 }}>
            <img src={iconEditarLead} alt="Editar modelo" title={'Editar modelo'} width={15} />
          </IconButton>
        )}
      </label>
      <div title={props.field?.length > 80 ? props.tooltip : null}>{props.date ? (props.field ? dayjs(props.field, 'DD/MM/YYYY').format('DD/MM/YYYY') : null) : props.field}</div>
    </div>
  );
}

// function BrandItem(data) {
//   return (
//     <>
//       {q.quotationBrandModels.map((qbm) => (
//         <>
//           <ReadOnlyInput key={"model-"+qbm.modelName} label={'Modelo:'} field={qbm.quantity + 'x - ' + qbm.modelName} span={q.span} date={q.date} expired={q.expired} classStyle={q.classStyle} tooltip={q.field} />
//           <ReadOnlyInput key={"price-"+qbm.modelName} field={'Preço: ' + qbm.price}  span={q.span} date={q.date} expired={q.expired} classStyle={q.classStyle} tooltip={q.field} />
//           {(qbm.discountApplied && qbm.discountApplied === true) && <ReadOnlyInput key={"discountApplied-"+qbm.modelName} field={'Desconto aprovado de ' + qbm.discount + '!'}  span={q.span} date={q.date} expired={q.expired} classStyle={q.classStyle} tooltip={q.field} />}
//           {qbm.observations && <ReadOnlyInput key={"observations-"+qbm.modelName} field={'Obs.: ' + qbm.observations}  span={q.span} date={q.date} expired={q.expired} classStyle={q.classStyle} tooltip={q.field} />}
//         </>
//       ))}
//       <ReadOnlyInput key={"quotationReplied-"+q.brandName} label={'Cotação respondida?'} field={(q.replied ? 'Sim' :'Não')} expired={!q.replied}  span={q.span} date={q.date} classStyle={q.classStyle} tooltip={q.field} />
//     </>
//   );
// }

function IdentifyLead() {
  const [searchField, setSearchField] = useState('');
  const initialSearch = useRef(true);
  const location = useLocation();
  const contract = useSelector(selectContract);
  const loadingContract = useSelector(selectContractLoading);
  const currentCase = useSelector(selectCurrentCase);
  const dispatch = useDispatch();

  async function handleSearch() {
    if (searchField === '') {
      dispatch(openModal({ type: 'info', message: 'Insira um CNPJ válido' }));
      return;
    }

    // const searchParams= {query: "?plate="+searchField};
    // if((!contract.plate || contract.unassigned) && (contract.case?.closeDate === null && !contract.case?.state.toLowerCase().includes("gestionado")))
    //   {
    //     dispatch(getContractSimple(searchParams))
    //   }
    // else {
    //   dispatch(getContract(searchParams));
    // }

    const searchFieldCleanned = searchField.replace(/[^\d]+/g, '');
    setSearchField(searchFieldCleanned);
    const searchParams = { query: '?cnpj=' + searchFieldCleanned };

    if ((!contract.customerCNPJ || contract.unassigned) && contract.case?.closeDate === null) {
      dispatch(getContractSimple(searchParams));
    } else {
      dispatch(getContract(searchParams));
    }
  }

  useEffect(() => {
    if (location?.state?.plate) {
      setSearchField(location.state.plate);
    }
  }, []);

  useEffect(() => {
    if (location?.state?.plate && initialSearch.current && searchField == location.state.plate) {
      initialSearch.current = false;
      delete location.state.plate;
      handleSearch();
    }
  }, [searchField]);

  async function handleAssign() {
    dispatch(associateContract({ body: { cnpj: contract.customerCNPJ, caseId: contract.case.caseId } }));
  }

  async function handleNoPlate() {
    dispatch(markCaseWithoutCNPJ({ query: `?caseId=${contract.case?.caseId}` })).then((data) => {
      dispatch(getContractByCaseId({ query: '?caseId=' + contract.case?.caseId }));
    });
  }

  function hasExpired() {
    const now = dayjs();
    const contractEndDate = dayjs(contract.contractEndDate, 'DD/MM/YYYY');
    const difference1 = now.diff(contractEndDate);
    if (difference1 > 0) {
      return true;
    } else return false;
  }

  const customerInfo = [
    // {label: "Nombre conductor", field: contract.driverName},
    // {label: "Apellido conductor", field: contract.driverSurname},
    // {label: "C.Cli", field: contract.customerCode},
    { label: 'Razão Social', field: contract.customerName, span: 2 },
    { label: 'Telefone', field: contract.customerPhone },
    { label: 'E-mail', field: contract.customerEmail },
    { label: 'CEP', field: formatToCEP(contract?.customer?.cep) },
    { label: 'Endereço', field: contract?.customer?.address },
    { label: 'Representante legal', field: contract?.customer?.legalRepresentative },
    { label: 'Cliente Cadastrado?', field: contract?.customerValid ? 'Sim' : 'Não' },
  ];

  const contractInfo = [
    { label: 'Fecha inicio contrato', field: contract.contractStartDate, date: true },
    { label: 'Fecha fin contrato', field: contract.contractEndDate, date: true },
    { label: 'Fecha terminación', field: contract.terminationdate, date: true },
    { label: 'Fecha estimada fin', field: contract.estimatedEndDate, date: true },
    { label: 'Neumáticos Contratados', field: contract.tyresContracted },
    { label: 'Tamaño neumático', field: contract.tyreSize },
    { label: 'Neumáticos ilimitados', field: contract.unlimitedTyres },
    { label: 'Tarjeta combustible', field: contract.gasCard ? 'Si' : 'No' },
    { label: 'Vehiculo sustitución', field: contract.replacementVehicle ? 'Si' : 'No' },
    { label: 'Tipo seguro', field: contract.insuranceType },
    { label: 'Servicio R&E', field: contract.vipService ? 'Si' : 'No' },
  ];

  const vehicleInfo = [
    { label: 'Marca', field: contract.brand },
    { label: 'Modelo', field: contract.model, span: 2 },
    { label: 'Nº bastidor', field: contract.chassisNumber },
    { label: 'Período', field: contract.periodContracted },
    { label: 'Distancia', field: contract.totalKmContracted },
    { label: 'No. licencia', field: contract.licenseNumber },
    { label: 'Nombre responsable fl.', field: contract.flManagerName },
    { label: 'Apellido responsable fl', field: contract.flManagerSurname },
    { label: 'Fin garantía', field: contract.guaranteeEndDate, date: true },
    { label: 'Grupo', field: contract.groupCode },
    { label: 'C.C.', field: contract.costCenter },
    { label: 'Compañía externa', field: contract.externalCompany },
    { label: 'Catalogación vehículo', field: contract.cataloguing },
    { label: 'Canal de venta veh.', field: contract.saleChanel },
    { label: 'Canal vehículo ocasión', field: contract.voChanel },
  ];

  const [customerDataForm, setCustomerDataForm] = useState({});
  const [customerFormOperation, setCustomerFormOperation] = useState(null);
  const [showCustomerDialog, setShowCustomerDialog] = useState(false);

  const [brandModelDialogForm, setBrandModelDialogForm] = useState({});
  const [showBrandModelDialog, setShowBrandModelDialog] = useState(false);

  function closeCustomerDialog() {
    setCustomerDataForm({});
    setShowCustomerDialog(false);
  }
  function openCustomerDialog() {
    setCustomerDataForm({
      CNPJ: contract.customerCNPJ,
      CustomerName: contract.customerName,
      Phone: contract.customerPhone,
      Email: contract.customerEmail,
      CEP: contract?.customer?.cep,
      Address: contract?.customer?.address,
      LegalRepresentative: contract?.customer?.legalRepresentative,
      isValid: contract.customerValid,
    });
    setCustomerFormOperation(contract.customerCNPJ == null ? 'delete' : '');
    setShowCustomerDialog(true);
  }
  function onChangeCustomerData(main, value) {
    if (main.toLowerCase() === 'phone') value = value.replace(/[^0-9+]/g, '');
    if (main.toLowerCase() === 'cep') value = value.replace(/[^0-9]/g, '');

    setCustomerDataForm((prevState) => ({ ...prevState, [main]: value }));
  }
  async function handleCustomerSubmit() {
    // Validação de Campos
    if (!customerDataForm.CNPJ || customerDataForm.CNPJ.trim() === '') {
      dispatch(openModal({ type: 'warning', message: `O campo CNPJ é obrigatório` }));
      return false;
    }
    if (!validateCNPJ(customerDataForm.CNPJ)) {
      dispatch(openModal({ type: 'warning', message: `Formato de CNPJ inválido` }));
      return false;
    }

    if (customerDataForm.CEP) {
      if (customerDataForm.CEP.length !== 8) {
        dispatch(openModal({ type: 'warning', message: `O campo CEP deve conter 8 caracteres` }));
        return false;
      }
    }

    //  if (!customerDataForm.CustomerName || customerDataForm.CustomerName.trim() === '') {
    //   dispatch(openModal({ type: 'warning', message: `O campo Razão Social é obrigatório` }));
    //   return false;
    // }
    //if (!customerDataForm.email || customerDataForm.email.trim() === '' || (customerDataForm.email && !customerDataForm.email.includes('@'))) {
    if (customerDataForm.Email) {
      if (!validateEmail(customerDataForm.Email)) {
        dispatch(openModal({ type: 'warning', message: `Formato de e-mail inválido` }));
        return false;
      }
    }
    if (!customerDataForm.Phone) {
      dispatch(openModal({ type: 'warning', message: `O campo Teefone é obrigatório` }));
      return false;
    }
    if (customerDataForm.Phone && customerDataForm.Phone.length < 10) {
      dispatch(openModal({ type: 'warning', message: `O campo Telefone deve conter no mínimo 10 caracteres` }));
      return false;
    }

    try {
      if (contract.customerCNPJ == null) {
        await dispatch(postCreateCustomer({ body: customerDataForm }));
      } else {
        await dispatch(postUpdateCustomer({ body: customerDataForm }));
      }
      dispatch(getContract({ query: '?cnpj=' + customerDataForm.CNPJ }));
      closeCustomerDialog();
    } catch (err) {
      dispatch(openModal(errorHandler(err)));
    }
  }

  return (
    <>
      <CustomerDialog
        editMode={contract.customerCNPJ != null}
        title={contract.customerCNPJ == null ? 'Cadastrar Cliente' : 'Editar Cliente'}
        operation={customerFormOperation}
        dialogSize={{ height: '100%' }}
        open={showCustomerDialog}
        onClose={closeCustomerDialog}
        handleOnClick={handleCustomerSubmit}
        dataForm={customerDataForm}
        onChange={onChangeCustomerData}
      ></CustomerDialog>

      <Box direction="row" width="100%" height={55} crossAlign="center">
        <Item ratio={1}>
          <div style={{ display: 'flex' }}>
            <SearchInput value={searchField} onClick={handleSearch} onChange={(e) => setSearchField(e.target.value)} />

            {contract?.unassigned && contract?.case?.closeDate === null && (
              <span>
                <IconButton onClick={handleAssign}>
                  <img src={saveIcon} alt="guardar" title={'Associar cliente'} width={20} />
                </IconButton>
              </span>
            )}
            {(contract.customerCNPJ == null || contract?.unassigned) &&
              contract?.case &&
              !contract.case.withoutCNPJ && //!contract.case.withoutPlate &&
              contract?.case.state !== 'Encerrado' &&
              !contract?.case?.state?.toLowerCase().includes('gestionado') &&
              !currentCase.withoutCNPJ && ( //!currentCase.withoutPlate && (
                <span>
                  <IconButton onClick={handleNoPlate}>
                    <img src={check} alt="Marcar caso como sem cliente" title={'Marcar caso como sem cliente'} width={20} />
                  </IconButton>
                </span>
              )}
            {(contract.customerCNPJ == null || contract?.unassigned) &&
              contract?.case &&
              contract.case.withoutCNPJ && //contract.case.withoutPlate &&
              (contract?.case.state !== 'Encerrado' || !contract?.case?.state?.toLowerCase().includes('gestionado')) &&
              currentCase.withoutCNPJ && ( //currentCase.withoutPlate && (
                <span>
                  <div style={{ padding: '12px 12px 10px 12px' }}>
                    <img src={check_green} alt="Marcado como sem cliente" title={'Marcado como sem cliente'} width={20} />
                  </div>
                </span>
              )}
          </div>
        </Item>
        <Item ratio={1}>
          <div className="iconbar-right">
            <div>
              {' '}
              <IconButton onClick={openCustomerDialog}>
                <img src={contract.customerCNPJ != null ? iconEditarLead : iconoAdd} alt="Editar cliente" title={'Editar cliente'} width={20} />
              </IconButton>
            </div>

            {contract && contract.exceptions && contract.exceptions.length > 0 && (
              <div>
                {' '}
                <FontAwesomeIcon icon={faExclamationTriangle} color="#AB4715" transform={{ size: 25 }} title="O cliente possui exceções" />
              </div>
            )}
            {contract && contract.uciCustomer && (
              <div>
                {' '}
                <FontAwesomeIcon icon={faCommentMedical} color="#B8504B" transform={{ size: 30 }} title="Cliente en UCI" />
              </div>
            )}
            {contract && contract.vip && (
              <div>
                {' '}
                <FontAwesomeIcon icon={faVuejs} color="#B9C40E" transform={{ size: 30 }} title="VIP" />
              </div>
            )}
            {contract && contract.highLevel && (
              <div>
                {' '}
                <FontAwesomeIcon icon={faDollarSign} color="#B9C40E" transform={{ size: 30 }} title="High Level" />
              </div>
            )}
            {contract && contract.alphacity && (
              <div>
                {' '}
                <FontAwesomeIcon icon={faUsers} color="#ED2024" transform={{ size: 30 }} title="Alphacity" />
              </div>
            )}
            {contract && contract.vipVehicle && (
              <div>
                {' '}
                <FontAwesomeIcon color="#FFD700" icon={faCar} transform={{ size: 30 }} title="Premium" />
              </div>
            )}
          </div>
        </Item>
      </Box>
      {contract.customerCNPJ ? (
        <div id="grid-contract-container">
          <div className="grid-contract">
            <ReadOnlyInput label={'CNPJ'} field={formatToCNPJ(contract.customerCNPJ)} expired={hasExpired()} />
            {/* <ReadOnlyInput label={"NPS"} field={<Gauge value={contract.nps}/>} classStyle="gauge-container"/> */}
          </div>
          <AccordionGroup
            key="customerData"
            setSelectedItems={true}
            data={[
              {
                title: 'Dados do cliente',
                body: customerInfo.map((e) => (
                  <ReadOnlyInput key={e.label} label={e.label} field={e.field} span={e.span} date={e.date} expired={e.expired} classStyle={e.classStyle} tooltip={e.field} />
                )),
              },
              // {title: "Dados contrato", body: contractInfo.map((e)=><ReadOnlyInput key={e.label} label={e.label} field={e.field} span={e.span} date={e.date} expired={e.expired} classStyle={e.classStyle} tooltip={e.field}/>)},
              // {title: "Dados vehículo", body: vehicleInfo.map((e)=><ReadOnlyInput key={e.label} label={e.label} field={e.field} span={e.span} date={e.date} expired={e.expired} classStyle={e.classStyle} tooltip={e.field}/>)}
            ]}
          />
        </div>
      ) : (
        <NoneSelectedMessage message={loadingContract !== 'succeeded' ? 'Nenhum cliente selecionado' : 'Nenhum cliente associado.'} />
      )}
    </>
  );
}

export { IdentifyLead };
